
<template>
	<v-dialog
			:value="isViewInventory"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View inventory</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Inventory type name"
							placeholder="Enter inventory type name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>

					<field
							margin="0"
							width="100%"
							label="Parent inventory type"
							placeholder="Select parent inventory type"
							@updateAutocomplete="onAutocomplete($event, 'parent_id')"
							:autocompleteValue="parent_id"
							:items="getModItems"
							:isClearable="false"
							item-text="name"
							item-value="id"
							is-autocomplete
					></field>

				</div>
				<div class="main">

				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapActions } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewInventory",
	components: { Preload },
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
		items: Array,
		editInventory: Object,
	},
	computed: {
		getModItems() {
			const item = { id: 0, name: 'There is no parent type', parent: 0 };
			return [ item, ...this.items ]; // Возвращаем новый массив с добавленным объектом в начале
		},
	},
	validations: {
		name: { required },
	},
	data: () => ({
		isViewInventory: true,
		id: null,
		name: null,
		parent_id: 0,
		isPreloader: false,
	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountInventorySave', 'onAccountInventoryEdit' ]),

		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { id, parent_id, name } = this.$data;
				const sendInfo = { name, parent_id };

				if (this.dialogFlag === 'add') {
					await this.onAccountInventorySave({ sendInfo });
				} else {
					await this.onAccountInventoryEdit({ sendInfo, id });
				}
				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreloader = false;

		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	mounted() {
		this.isPreloader = true;

		if (this.dialogFlag === 'add') {
			this.id = null;
			this.name = null;
			this.parent_id = 0;
		} else {
			this.id = this.editInventory.id;
			this.name = this.editInventory.name;
			this.parent_id = this.editInventory.parent_id;
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";
</style>
